import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../stores/authStore';

const UnprotectedRoute = ({ children }) => {
  const accessToken = useAuthStore((state) => state.accessToken);
  const justVerified = useAuthStore((state) => state.justVerified);

  if (accessToken && !justVerified) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default UnprotectedRoute; 